// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*============================================*/
/* VPO style */
.vpo-search img {
  width: 100%;
}

@media (max-width: 767px) {
  .vpo-search {
    flex-direction: column;
  }
  .vpo-search .col, .vpo-search img {
    width: 100%;
    max-width: 100%;
  }
  .vpo-search img {
    margin-bottom: 1.5rem;
    max-height: 400px;
  }
}
@media (max-width: 575px) {
  .vpo-search {
    margin: 1.5rem 0;
  }
  .vpo-search__content {
    font-size: 16px;
  }
  .listofPrograms_promoVpo {
    flex-direction: column;
    margin-top: 0;
    margin-bottom: 1.5rem;
  }
}
/*============================================*/
/* Business style */
/*============================================*/
.accomodation-container {
  max-width: 550px;
  width: 100%;
}
.accomodation-container a {
  display: inline-block;
  padding-bottom: 10px;
}
.accomodation-container img {
  width: 100%;
}

.accomodation-container.left {
  margin-left: auto;
}

.accomodation-container.right {
  margin-right: auto;
}

@media (max-width: 767px) {
  .accomodation {
    margin-top: 1.5rem !important;
  }
  .accomodation-container.left {
    margin: 0 auto;
  }
  .accomodation-container.right {
    margin: 0 auto;
  }
  .accomodation-inner {
    flex-direction: column;
    margin-top: 1.5rem !important;
  }
  .accomodation-inner .col, .accomodation-inner img {
    width: 100%;
    max-width: 100%;
  }
  .accomodation-inner .portal-img {
    margin-bottom: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/content.scss"],"names":[],"mappings":"AAAA,+CAAA;AACA,cAAA;AAGI;EACI,WAAA;AADR;;AAKA;EACI;IACI,sBAAA;EAFN;EAIM;IACI,WAAA;IACA,eAAA;EAFV;EAKM;IACI,qBAAA;IACA,iBAAA;EAHV;AACF;AAOA;EACI;IACI,gBAAA;EALN;EAOM;IACI,eAAA;EALV;EASE;IACI,sBAAA;IACA,aAAA;IACA,qBAAA;EAPN;AACF;AAWA,+CAAA;AACA,mBAAA;AACA,+CAAA;AAEA;EACI,gBAAA;EACA,WAAA;AAVJ;AAYI;EACI,qBAAA;EACA,oBAAA;AAVR;AAaI;EACI,WAAA;AAXR;;AAeA;EACI,iBAAA;AAZJ;;AAeA;EACI,kBAAA;AAZJ;;AAeA;EAEI;IACI,6BAAA;EAbN;EAgBE;IACI,cAAA;EAdN;EAiBE;IACI,cAAA;EAfN;EAkBE;IACI,sBAAA;IACA,6BAAA;EAhBN;EAkBM;IACI,WAAA;IACA,eAAA;EAhBV;EAmBM;IACI,qBAAA;EAjBV;AACF","sourcesContent":["/*============================================*/\n/* VPO style */\n\n.vpo-search {\n    img {\n        width: 100%;\n    }\n}\n\n@media (max-width: 767px) {\n    .vpo-search {\n        flex-direction: column;\n\n        .col, img {\n            width: 100%;\n            max-width: 100%;\n        }\n\n        img {\n            margin-bottom: 1.5rem;\n            max-height: 400px;\n        }\n    }\n}\n\n@media (max-width: 575px) { \n    .vpo-search { \n        margin: 1.5rem 0;\n\n        &__content {\n            font-size: 16px;\n        }\n    }\n\n    .listofPrograms_promoVpo {\n        flex-direction: column;\n        margin-top: 0;\n        margin-bottom: 1.5rem;\n    }\n}\n\n\n/*============================================*/\n/* Business style */\n/*============================================*/\n\n.accomodation-container {\n    max-width: 550px;\n    width: 100%;\n\n    a {\n        display: inline-block;\n        padding-bottom: 10px;\n    }\n\n    img {\n        width: 100%;\n    }\n}\n\n.accomodation-container.left {\n    margin-left: auto;\n}\n\n.accomodation-container.right {\n    margin-right: auto;\n}\n\n@media (max-width: 767px) {\n    \n    .accomodation {\n        margin-top: 1.5rem !important;\n    }\n\n    .accomodation-container.left {\n        margin: 0 auto;\n    }\n    \n    .accomodation-container.right {\n        margin: 0 auto;\n    }\n\n    .accomodation-inner {\n        flex-direction: column;\n        margin-top: 1.5rem !important;\n\n        .col, img {\n            width: 100%;\n            max-width: 100%;\n        }\n\n        .portal-img {\n            margin-bottom: 1.5rem;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
